module.exports = __webpack_public_path__ + "static/img/faq4.1af873f.png";